import { createContext, useContext } from 'react';

export interface SharedAuthContextValue {
  isLogged: boolean;
  userId?: string;
}

export const SharedAuthContext = createContext<SharedAuthContextValue>({
  isLogged: false
});

export const useSharedAuth = () => useContext(SharedAuthContext);
